export const USER_DETAILS_NAME = 'BondUserIdToken';
export const CONSUMER_DATA_ADDED = 'custom:consumerDataAdded';
export const COGNITO_USERNAME = 'cognito:username';
export const BACKOFFICE_DATA_ADDED = 'custom:backofficeDataAdded';
export const USER_ID_KEY = 'custom:userId';
